import type { Player, ShopBuyResponse } from "@utah-vr/shared";

export async function fetchPlayer(): Promise<Player> {
	const res = await fetch("/api/player");
	if (!res.ok) throw new Error(`player fetch failed: ${res.status}`);
	return res.json();
}

export async function buy(sku: string, qty = 1): Promise<ShopBuyResponse> {
	const res = await fetch("/api/shop/buy", {
		method: "POST",
		headers: { "content-type": "application/json" },
		body: JSON.stringify({ sku, qty }),
	});
	return res.json();
}

export async function repairPrinter(id: string): Promise<{ ok?: true; error?: string; printer?: import("@utah-vr/shared").Printer }> {
	const res = await fetch(`/api/printer/${encodeURIComponent(id)}/repair`, { method: "POST" });
	return res.json();
}

export async function sellPrinter(id: string): Promise<{ ok?: true; refundCents?: number; error?: string }> {
	const res = await fetch(`/api/printer/${encodeURIComponent(id)}/sell`, { method: "POST" });
	return res.json();
}

export async function upgradeWarehouse(id: string): Promise<{ ok?: true; error?: string }> {
	const res = await fetch(`/api/warehouse/${encodeURIComponent(id)}/upgrade`, { method: "POST" });
	return res.json();
}
